import type { StoreLocation } from './types';

// ─── Brand Config ──────────────────────────────────────────────────────────────

// Brand logo URL (Stored locally in public directory for 100% corporate Wi-Fi & offline reliability)
export const BRAND_LOGO_URL = '/intema_logo.png';

// ─── Kitchen Compatibility Rules ───────────────────────────────────────────────

export const KITCHEN_COMPATIBILITY_RULES_DEFAULT: Record<string, Record<string, string[]>> = {
  "PRIME": {
    "Doğal Ahşap Kaplama": [
      "Düşey Hareli Natürel Meşe",
      "Düşey Hareli İskadinav Meşe",
      "Düşey Hareli İsli Meşe",
      "Düşey Hareli Kahve Meşe"
    ],
    "Parlak Lake": [
      "Buz Beyaz",
      "Açık Kül Gri",
      "Sis Gri"
    ],
    "Dokulu Melamin": [
      "Beton",
      "Freze İsli Ceviz",
      "Freze Meşe",
      "Freze Ceviz",
      "Rustik Meşe",
      "Koyu Ceviz"
    ],
    "Soft Pet": [
      "Kar Beyaz",
      "Duman Gri",
      "Vanilya Beji",
      "Hasır Beji",
      "Kuvarsit Beji"
    ],
    "Düz Melamin": [
      "Mat Beyaz",
      "Duman Gri",
      "Latte",
      "Grafit"
    ],
    "Soft Lak": [
      "İpek Beyaz",
      "Çelik Gri",
      "Latte",
      "Grafit",
      "Muskat",
      "Kum Beji"
    ],
    "Metal Görünümlü": [
      "Açık Bakır"
    ],
    "Akrilik Pet": [
      "Sıcak Beyaz",
      "Açık Gri Bej",
      "Karbon Gri"
    ],
    "Mat Pet": [
      "Süt Beyaz",
      "Koyu Taupe",
      "Okyanus Mavi",
      "Kömür Siyah",
      "Kil Beyazı",
      "Baltık Mavi",
      "Adaçayı Yeşili",
      "Açık Gri",
      "Kaşmir",
      "Manolya",
      "Hareli Açık Meşe",
      "Hareli Koyu Ceviz",
      "Puslu Meşe"
    ],
    "Parlak Kristal Pet": [
      "Süt Beyaz",
      "Kil Beji"
    ],
    "Mat Polimerik": [
      "Hareli Açık Meşe",
      "Puslu Meşe",
      "Hareli Koyu Ceviz"
    ],
    "Mat Lake": [
      "Buz Beyaz",
      "Açık Kül Gri",
      "Vizon",
      "Siyah",
      "Sis Gri",
      "İpek Gri",
      "Pembe Taupe",
      "Taş Gri",
      "Gümüş Gri",
      "İnci Beyaz",
      "Beton Yeşili",
      "Baltık Gri",
      "Kaşmir",
      "Haki",
      "Bej",
      "Gölge Gri",
      "Duman Yeşili"
    ],
    "Mat Kristal Pet": [
      "Süt Beyaz",
      "Açık Mocha",
      "Kül Gri",
      "Taş Siyah",
      "Katran",
      "İnci Grisi",
      "Pudra Beji",
      "Keten Beyazı"
    ]
  },
  "INOVA": {
    "Doğal Ahşap Kaplama": [
      "Düşey Hareli Natürel Meşe",
      "Düşey Hareli İskadinav Meşe",
      "Düşey Hareli İsli Meşe",
      "Düşey Hareli Kahve Meşe"
    ],
    "Parlak Lake": [
      "Buz Beyaz",
      "Açık Kül Gri",
      "Sis Gri"
    ],
    "Dokulu Melamin": [
      "Beton",
      "Freze İsli Ceviz",
      "Freze Meşe",
      "Freze Ceviz",
      "Rustik Meşe",
      "Koyu Ceviz"
    ],
    "Soft Pet": [
      "Kar Beyaz",
      "Duman Gri",
      "Vanilya Beji",
      "Hasır Beji",
      "Kuvarsit Beji"
    ],
    "Düz Melamin": [
      "Mat Beyaz",
      "Duman Gri",
      "Latte",
      "Grafit"
    ],
    "Soft Lak": [
      "İpek Beyaz",
      "Çelik Gri",
      "Latte",
      "Grafit",
      "Muskat",
      "Kum Beji"
    ],
    "Metal Görünümlü": [
      "Açık Bakır"
    ],
    "Akrilik Pet": [
      "Sıcak Beyaz",
      "Açık Gri Bej",
      "Karbon Gri"
    ],
    "Mat Pet": [
      "Süt Beyaz",
      "Koyu Taupe",
      "Okyanus Mavi",
      "Kömür Siyah",
      "Kil Beyazı",
      "Baltık Mavi",
      "Adaçayı Yeşili",
      "Açık Gri",
      "Kaşmir",
      "Manolya",
      "Hareli Açık Meşe",
      "Hareli Koyu Ceviz",
      "Puslu Meşe"
    ],
    "Parlak Kristal Pet": [
      "Süt Beyaz",
      "Kil Beji"
    ],
    "Mat Polimerik": [
      "Hareli Açık Meşe",
      "Puslu Meşe",
      "Hareli Koyu Ceviz"
    ],
    "Mat Lake": [
      "Buz Beyaz",
      "Açık Kül Gri",
      "Vizon",
      "Siyah",
      "Sis Gri",
      "İpek Gri",
      "Pembe Taupe",
      "Taş Gri",
      "Gümüş Gri",
      "İnci Beyaz",
      "Beton Yeşili",
      "Baltık Gri",
      "Kaşmir",
      "Haki",
      "Bej",
      "Gölge Gri",
      "Duman Yeşili"
    ],
    "Mat Kristal Pet": [
      "Süt Beyaz",
      "Açık Mocha",
      "Kül Gri",
      "Taş Siyah",
      "Katran",
      "İnci Grisi",
      "Pudra Beji",
      "Keten Beyazı"
    ]
  },
  "FRESCA": {
    "Mat Lake": [
      "Buz Beyaz",
      "Açık Kül Gri",
      "Vizon",
      "Sis Gri",
      "İpek Gri",
      "Baltık Mavi",
      "Beton Yeşili",
      "Buz Gri",
      "Baltık Gri",
      "İnci Beyaz",
      "Kaşmir",
      "Haki",
      "Bej",
      "Gölge Gri",
      "Duman Yeşili"
    ],
    "Mat Polimerik": [
      "Okyanus Mavi",
      "Hareli Açık Meşe",
      "Puslu Meşe"
    ],
    "Mat Pet": [
      "Süt Beyaz",
      "Koyu Taupe",
      "Kil Beyazı",
      "Baltık Mavi",
      "Adaçayı Yeşili",
      "Açık Gri",
      "Kaşmir",
      "Manolya"
    ]
  },
  "VEGA": {
    "Mat Lake": [
      "Buz Beyaz",
      "Açık Kül Gri",
      "Vizon",
      "Sis Gri",
      "İpek Gri",
      "Baltık Mavi",
      "Beton Yeşili",
      "Buz Gri",
      "Baltık Gri",
      "İnci Beyaz",
      "Kaşmir",
      "Haki",
      "Bej",
      "Gölge Gri",
      "Duman Yeşili"
    ],
    "Mat Polimerik": [
      "Okyanus Mavi",
      "Hareli Açık Meşe",
      "Puslu Meşe"
    ],
    "Mat Pet": [
      "Süt Beyaz",
      "Koyu Taupe",
      "Kil Beyazı",
      "Baltık Mavi",
      "Adaçayı Yeşili",
      "Açık Gri",
      "Kaşmir",
      "Manolya"
    ]
  },
  "NORDA": {
    "Doğal Ahşap Kaplama": [
      "Düşey Hareli Natürel Meşe",
      "Düşey Hareli İskadinav Meşe",
      "Düşey Hareli İsli Meşe",
      "Düşey Hareli Kahve Meşe"
    ],
    "Mat Lake": [
      "Buz Beyaz",
      "Açık Kül Gri",
      "Sis Gri",
      "İpek Gri",
      "Taş Gri",
      "Gümüş Gri",
      "Beton Yeşili",
      "Buz Gri",
      "Baltık Gri",
      "İnci Beyaz",
      "Kaşmir",
      "Haki",
      "Bej",
      "Gölge Gri",
      "Duman Yeşili"
    ]
  },
  "SIENA": {
    "Mat Pet": [
      "Süt Beyaz",
      "Kil Beyazı",
      "Baltık Mavi",
      "Açık Gri",
      "Kaşmir",
      "Manolya"
    ]
  },
  "TOSCANA": {
    "Mat Lake": [
      "Buz Beyaz",
      "Açık Kül Gri",
      "Vizon",
      "Sis Gri",
      "İpek Gri",
      "Baltık Gri",
      "İnci Beyaz",
      "Kaşmir",
      "Haki",
      "Bej",
      "Gölge Gri",
      "Duman Yeşili"
    ],
    "Parlak Lake": [
      "Açık Kül Gri",
      "Sis Gri",
      "İnci Beyaz",
      "Taupe Parlak",
      "Orman Yeşili Parlak",
      "Uzay Mavi Parlak"
    ]
  }
};

// ─── Kitchen Config Dropdowns ──────────────────────────────────────────────────

export const BODY_COLORS = ['Antrasit', 'Beyaz', 'Koton Vizon'];
export const PLINTH_HEIGHTS = ['Baza 12 cm'];
export const GLASS_TYPES = ['Füme Reflekte Cam', 'Ondüle Cam', 'Sable Cam', 'Düz Cam'];
export const PROFILE_COLORS = ['Mat Siyah', 'Antrasit', 'Parlak Alüminyum', 'Satine Bronz'];
export const PROFILE_TYPES = [
  'Dar Profil',
  'Verev Profil',
  'Yapışmalı Geniş Profil',
  'Polimerik Çerçeveli Cam Kapak',
  'Parlak/Mat Lake MDF Çerçeveli Cam Kapak',
  'Mat Lake Toscana Çıtalı Cam Kapak',
  'Parlak Lake Toscana Çıtalı Cam Kapak',
  'Mat Lake Vega Çıtalı Cam Kapak',
  'Polimerik Vega Çıtalı Cam Kapak',
  'Polimerik Siena Çıtalı Cam Kapak',
];
export const LEAD_TIMES = ['2 hafta', '3 hafta', '4 hafta', '5 hafta', '6 hafta', '7 hafta', '8 hafta', '9 hafta', '10 hafta', '11 hafta', '12 hafta'];

// Toplu proje Ticari Koşullar'ındaki "Ödeme Şekli: " maddesinin varsayılan devamı — Düzenle modunda alan boş bırakılırsa kullanılır.
export const DEFAULT_PAYMENT_TERMS = 'Anlaşma ile %50 Peşin, Kalan bakiye 30-60-90 gün eşit tutarlarda sıralı vadeli çek.';

// Proje Notu alanı için üst sınır — Proje Özeti sayfasının yapısını bozup diğer sayfaya taşmaması için sınırlandırılmış.
export const PROJECT_NOTE_MAX_LENGTH = 280;

// ─── Store Locations ───────────────────────────────────────────────────────────

export const STORE_LOCATIONS: StoreLocation[] = [
  { name: 'İntema Adana Mağaza', address: 'Atatürk Cad. No:46/A, 01120 Seyhan/Adana', phone: '(0322) 457 96 63', ticariUnvan: 'İntema İnşaat ve Tesisat Malzemeleri Yatırım ve Pazarlama A.Ş.' },
  { name: 'İntema Ankara Mağaza', address: 'Turan Güneş Bulvarı No:86 Çankaya / Ankara', phone: '(0312) 440 85 96', ticariUnvan: 'İntema İnşaat ve Tesisat Malzemeleri Yatırım ve Pazarlama A.Ş.' },
  { name: 'İntema Bodrum Mağaza', address: 'Konacık, Atatürk Blv. No:14/2 D:4, 48400 Bodrum/Muğla', phone: '(0252) 999 19 50', ticariUnvan: 'İntema İnşaat ve Tesisat Malzemeleri Yatırım ve Pazarlama A.Ş.' },
  { name: 'Ronay Yapı', address: 'Cevizli Mah. Bağdat Cad. No: 563 B Maltepe/ İstanbul', phone: '', ticariUnvan: 'Ronay İnşaat Yapı Malzemeleri Sanayi Ticaret Limited Şirketi' },
  { name: 'İntema İzmir Mağaza', address: 'Şehit Nevres Bulvarı No:10 Deren Plaza Montrö Meydanı İzmir', phone: '(0232) 446 48 38', ticariUnvan: 'İntema İnşaat ve Tesisat Malzemeleri Yatırım ve Pazarlama A.Ş.' },
  { name: 'İntema Samsun Mağaza', address: 'Denizevleri, Atatürk Blv. No:82, 55200 Atakum/Samsun', phone: '(0362) 438 39 18', ticariUnvan: 'İntema İnşaat ve Tesisat Malzemeleri Yatırım ve Pazarlama A.Ş.' },
  { name: 'Moliza Mutfak', address: 'Hafsa Sultan Mah. Mimar Sinan Blv. No: 158 Yunus Emre/ Manisa', phone: '', ticariUnvan: 'Moliza Mutfak Mobilya Sanayi ve Ticaret Limited Şirketi' },
  { name: 'İntema Suadiye Mağaza', address: 'Bağdat Cad. No: 493, 34744 Kadıköy/ İstanbul', phone: '(0216) 467 06 40', ticariUnvan: 'İntema İnşaat ve Tesisat Malzemeleri Yatırım ve Pazarlama A.Ş.' },
  { name: 'ABM Gayrimenkul - Çorlu', address: 'ABM Vitra Mağaza - Muhittin mahallesi Çetin emeç cad. No:16/2 Çorlu -Tekirdağ', phone: '(0282) 652 28 06', ticariUnvan: 'Abm Gayrimenkul ve İnşaat Malzemeleri Tic.San. A.Ş.' },
  { name: 'ABM Gayrimenkul - Edirne', address: 'Cumhuriyet Mahallesi Süleoğlu Yolu No:306/8 Merkez/Edirne', phone: '(0284) 212 34 34', ticariUnvan: 'Abm Gayrimenkul ve İnşaat Malzemeleri Tic.San. A.Ş.' },
  { name: 'ABM Gayrimenkul - Tekirdağ', address: 'Hürriyet Mahallesi Şehit Serkan Tuban Cd. No: 13/B, 59030 Süleymanpaşa Tekirdağ', phone: '(0282)2933030', ticariUnvan: 'Abm Gayrimenkul ve İnşaat Malzemeleri Tic.San. A.Ş.' },
  { name: 'Alze Yapı', address: 'Göktürk Merkez, Camii Sok. No:4/I, 34077 Eyüpsultan/İstanbul', phone: '(0212) 322 92 22', ticariUnvan: 'Alze Yapı Gayrimenkul Tic.Ltd.Şti' },
  { name: 'Başar İş', address: 'Ekinciler Cad. Ertürk Sok. No:4 Beykoz/İstanbul', phone: '(0216) 331 46 00-01-02-03', ticariUnvan: 'Başar İş İnş. Müh. San. Ltd. Şti.' },
  { name: 'Bakırlar Yapı', address: 'Fener Kalamış Cd. No:16 D:18/A Kalamış / İstanbul', phone: '444 25 11', ticariUnvan: 'Bakırlar Yapı Malzemeleri İnşaat ve Tic. Ltd. Şti.' },
  { name: 'Beks Desgin', address: 'Rüzgarlı bahçe Mah. Cumhuriyet Cad. No:81/A Beykoz / İstanbul', phone: '(0216) 331 01 11', ticariUnvan: 'Beks Design Yapı Malz. İth. İhr. ve Tic. Ltd. Şti.' },
  { name: 'BM Kolleksiyon', address: 'İzmir Yolu Küçük Sanayi Kavşağı Ersan Sokak Nilüfer Ticaret Merkezi Ön Blok No:10 Nilüfer / Bursa', phone: '(0224) 443 21 21', ticariUnvan: 'Bm Kolleksiyon Mobilya İnş. ve Yapı Malz. Turizm Otelcilik San. Tic. A.' },
  { name: 'BND Mimarlık', address: 'Çayyolu Konsept Villaları 2715. Sok. No:2/6A Ümitköy / Ankara', phone: '(0312) 241 06 46', ticariUnvan: 'Bnd Mim. Tasarım Proje Dek. İnş. San. ve Tic. Ltd. Şti.' },
  { name: 'Çarıklıoğlu Yapı', address: 'Güllü Bağlar, Ankara Cd. No: 270, 34906 Pendik/İstanbul', phone: '(0552) 830 67 15', ticariUnvan: 'Çarıklıoğlu Yapı Malz. İth. İhr. ve Tic. Ltd. Şti.' },
  { name: 'Eskihisar İnşaat', address: 'Beytepe Mahallesi, Beyler Caddesi, 5343. Sokak, Keyvan Acrux No:1/d, Çankaya/Ankara', phone: '(0312) 309 13 20', ticariUnvan: 'Eskihisar İnş. Malz. San. ve Tic. A.Ş' },
  { name: 'Faruk Ulular', address: 'Furkandede Cad. No:33/A (Yeni Larende Cad.) Konya', phone: '(0332) 352 19 19', ticariUnvan: 'Faruk Ulular Doğalgaz ve Isı Sistem İnş. Mak. San. Tic. Ltd. Şti.' },
  { name: 'Güneyliler Yapı', address: 'Şemsettin Günaltay Cad. No:205 Kadıköy/İstanbul', phone: '(0216) 411 87 56-57-58', ticariUnvan: 'Güneyliler Yapı Malz.San. ve. Tic. Ltd. Şti.' },
  { name: 'Mas Yapı', address: 'Paşaalanı Mah. A. Gaffar Okan Cad. No:81/A Karesi / Balıkesir', phone: '(0542) 457 44 84', ticariUnvan: 'Mas Cephe Sistemleri İnşaat San. ve Tic. Ltd. Şti.' },
  { name: 'Neslibey Demirhan Yapı Malzemeleri', address: 'Tepeüstü, Alemdağ Cd. No:544, Ümraniye/İstanbul', phone: '(0530) 100 2852', ticariUnvan: 'Neslibey Demirhan Yapı Malz. İnş. Malzemeleri Tur. Teks. San. ve Tic. Ltd. Şti.' },
  { name: 'Olcay Yapı- Bakırköy', address: 'Şenlikköy Mahallesi Eski Halkalı Cad. No:3/6 Bakırköy/İstanbul', phone: '(0212) 651 19 95', ticariUnvan: 'Olcay Yp.Ml.Tic.İnş.ve Tah.A.Ş' },
  { name: 'Olcay Yapı - Etiler', address: 'Nispetiye Caddesi No:29/A Etiler / İstanbul', phone: '(0212) 269 30 03', ticariUnvan: 'Olcay Yp.Ml.Tic.İnş.ve Tah.A.Ş' },
  { name: 'Olcay Yapı - Kartal', address: 'Yeşilbağlar, Pera Plaza, D:100 Blv. B Blok No: 20/H, 34893 Pendik/İstanbul', phone: '(0216)5148001', ticariUnvan: 'Olcay Yp.Ml.Tic.İnş.ve Tah.A.Ş' },
  { name: 'Sarıkadıoğlu Mimarlık', address: 'Fığla mah. 322.sk no:7 Yağız Granite Marble Alanya/Antalya', phone: '(0533) 044 40 00', ticariUnvan: 'Sarıkadıoğlu Mimarlık Mühendislik Emlak Turizm Ticaret Limited Şirketi' },
  { name: 'Sayıtoğlu Yapı', address: 'Pelitli TOKİ İş Merkezi Pelitli Mahallesi Rize caddesi No:24K A Blok İşyeri:6 Ortahisar / Trabzon', phone: '(0462)444 2 556 - (0532) 155 55 22', ticariUnvan: 'Sayitoğlu Yapı Mlz.Paz.Tic.Ltd.Şti.' },
  { name: 'Stillay', address: 'Kültür Mah. 722. Sok. No:3 Merkez/Düzce / Düzce', phone: '(0380) 731 28 00', ticariUnvan: 'Stillay Mobilya San. ve Tic. A.Ş.' },
  { name: 'Vien Mimarlık', address: 'Yalı Mah. Mithatpaşa Cad. No:535A Güzelbahçe / İzmir', phone: '(0533) 134 24 78', ticariUnvan: 'Vien Mimarlık İnşaat San. ve Tic. Ltd. Şti.' },
  { name: 'Yapı Smart', address: 'Aşık Veysel Mah. Cemal Paşa Cad. Semarkandline Sit. A Blok  No:5 Esenyurt / İstanbul', phone: '0(212) 598 88 88', ticariUnvan: 'Yapı Smart İnşaat Malzemeleri San. Tic. Ltd. Şti.' },
  { name: 'Zeyka Mimarlık', address: 'Donanmacı Mah. Yalı Blv. No:326 A Karşıyaka / İzmir', phone: '0 (531) 366 35 48', ticariUnvan: 'Zeyka Mimarlık İnşaat Ticaret Limited Şirketi' }
].sort((a, b) => a.name.localeCompare(b.name, 'tr'));
